import { useEffect } from 'react'

import { useLocation, useNavigate } from '@tanstack/react-router'

import { Splash } from '@forto-dev/phoenix-ui-core/ship'

import { useAuth } from '../../api/useAuth'
import { loginRoute } from '../../routes'

const SHIP_TOKEN_COOKIE_NAME = 'shipToken'

const getCookieValue = (cookieName: string): string | null => {
  const cookie = document.cookie.match('(^|;) ?' + cookieName + '=([^;]*)(;|$)')
  return cookie ? cookie[2] : null
}

const removeCookie = (cookieName: string): void => {
  // removing subdomain to destroy cookie, since the domain+path need to match (e.g. ship-v2.forto.com -> forto.com)
  const domains = document.location.host.split('.')
  if (domains.length < 2) {
    // Handle invalid hostname
    document.cookie = `${cookieName}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/;`
    return
  }
  domains.shift()
  const mainDomain = domains.join('.')
  document.cookie = `${cookieName}=; Expires=Thu, 01 Jan 1970 00:00:00 GMT; Path=/; Domain=.${mainDomain};`
}

export const LoginAs = () => {
  const { loginAsCustomer } = useAuth()
  const navigate = useNavigate()
  const location = useLocation()

  useEffect(() => {
    const token = getCookieValue(SHIP_TOKEN_COOKIE_NAME)
    if (token) {
      removeCookie(SHIP_TOKEN_COOKIE_NAME)
      loginAsCustomer(token)
        .then(() => {
          navigate({
            to: String('redirect' in location.search ? location.search.redirect : '/'),
            from: location.pathname,
          })
        })
        .catch(() => {
          navigate({
            to: loginRoute.fullPath,
            from: location.pathname,
          })
        })
    } else {
      navigate({
        to: String('redirect' in location.search ? location.search.redirect : '/'),
        from: location.pathname,
      })
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return <Splash />
}
